import i18n from "src/i18n/i18n";
import * as Yup from "yup";

export default class InvoiceClientConfig {
    id: number;
    client_id: number;
    invoice_expeditor_id: number;
    note: string;
    font: string;
    font_size: string;
    font_size_title: string;
    combine: number;
    conf_cfdi_uses: number;
    conf_obj_imp: number;
    conf_payment_methods: number;
    conf_payment_types: number;
    conf_prod_serv_keys: number;
    conf_tax_regimes_expeditor: number;
    conf_tax_regimes_client: number;
    conf_tax_types: number;
    conf_tax_types_items: number;
    conf_unit_keys: number;
    created_at: string;
    updated_at: string;

    static getRules(invoiceClientConfig: InvoiceClientConfig) {
        return Yup.object().shape({
            client_id: Yup.number()
                .required(i18n.t("VALIDATION.REQUIRED")),
            invoice_expeditor_id: Yup.number()
                .required(i18n.t("VALIDATION.REQUIRED")),
            note: Yup.string()
                .max(500),
            font: Yup.string()
                .max(50)
                .required(i18n.t("VALIDATION.REQUIRED")),
            font_size: Yup.string()
                .max(30)
                .required(i18n.t("VALIDATION.REQUIRED")),
            font_size_title: Yup.string()
                .max(30)
                .required(i18n.t("VALIDATION.REQUIRED")),
            combine: Yup.number()
                .min(0)
                .max(2)
                .required(i18n.t("VALIDATION.REQUIRED")),
            conf_cfdi_uses: Yup.number()
                .min(0)
                .max(2)
                .required(i18n.t("VALIDATION.REQUIRED")),
            conf_obj_imp: Yup.number()
                .min(0)
                .max(2)
                .required(i18n.t("VALIDATION.REQUIRED")),
            conf_payment_methods: Yup.number()
                .min(0)
                .max(2)
                .required(i18n.t("VALIDATION.REQUIRED")),
            conf_payment_types: Yup.number()
                .min(0)
                .max(2)
                .required(i18n.t("VALIDATION.REQUIRED")),
            conf_prod_serv_keys: Yup.number()
                .min(0)
                .max(2)
                .required(i18n.t("VALIDATION.REQUIRED")),
            conf_tax_regimes_expeditor: Yup.number()
                .min(0)
                .max(2)
                .required(i18n.t("VALIDATION.REQUIRED")),
            conf_tax_regimes_client: Yup.number()
                .min(0)
                .max(2)
                .required(i18n.t("VALIDATION.REQUIRED")),
            conf_tax_types: Yup.number()
                .min(0)
                .max(2)
                .required(i18n.t("VALIDATION.REQUIRED")),
            conf_tax_types_items: Yup.number()
                .min(0)
                .max(2)
                .required(i18n.t("VALIDATION.REQUIRED")),
            conf_unit_keys: Yup.number()
                .min(0)
                .max(2)
                .required(i18n.t("VALIDATION.REQUIRED")),
        })
    }

    static getInitValues(invoiceClientConfig: InvoiceClientConfig) {
        return {
            client_id: invoiceClientConfig ? invoiceClientConfig.client_id : "",
            invoice_expeditor_id: invoiceClientConfig ? invoiceClientConfig.invoice_expeditor_id : "",
            note: invoiceClientConfig ? invoiceClientConfig.note : "",
            font: invoiceClientConfig ? invoiceClientConfig.font : "Arial",
            font_size: invoiceClientConfig ? invoiceClientConfig.font_size : "10px",
            font_size_title: invoiceClientConfig ? invoiceClientConfig.font_size_title : "14px",
            combine: invoiceClientConfig ? invoiceClientConfig.combine : "0",
            conf_cfdi_uses: invoiceClientConfig ? invoiceClientConfig.conf_cfdi_uses : "0",
            conf_obj_imp: invoiceClientConfig ? invoiceClientConfig.conf_obj_imp : "0",
            conf_payment_methods: invoiceClientConfig ? invoiceClientConfig.conf_payment_methods : "0",
            conf_payment_types: invoiceClientConfig ? invoiceClientConfig.conf_payment_types : "0",
            conf_prod_serv_keys: invoiceClientConfig ? invoiceClientConfig.conf_prod_serv_keys : "0",
            conf_tax_regimes_expeditor: invoiceClientConfig ? invoiceClientConfig.conf_tax_regimes_expeditor : "0",
            conf_tax_regimes_client: invoiceClientConfig ? invoiceClientConfig.conf_tax_regimes_client : "0",
            conf_tax_types: invoiceClientConfig ? invoiceClientConfig.conf_tax_types : "0",
            conf_tax_types_items: invoiceClientConfig ? invoiceClientConfig.conf_tax_types_items : "0",
            conf_unit_keys: invoiceClientConfig ? invoiceClientConfig.conf_unit_keys : "0",
        }
    }
}
